<script setup>
import { useSlots } from 'vue';
import { PENDING_STRIPE } from '../constants/constants';

defineProps({
  logo: {
    type: String,
    default: null,
  },
  fontColorLogo: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  button: {
    type: String,
    default: null,
  },
  status: {
    type: String,
    default: null,
  },
});

const slots = useSlots();
const hasSlot = (slot) => !!slots[slot];
const emit = defineEmits([ 'on-click-empty-table' ]);
</script>

<template>
  <div class="card-empty-table">
    <div :class="`card-empty-table__logo-container card-empty-table__logo-container--${fontColorLogo}`">
      <slot v-if="hasSlot('icon')" name="icon" />
      <span v-else :class="`card-empty-table__logo--${logo}`" />
    </div>
    <div class="card-empty-table__title">
      {{ title }}
    </div>
    <div class="card-empty-table__subtitle">
      {{ subtitle }}
    </div>
    <button
      v-if="button"
      class="card-empty-table__button btn btn--primary btn--small"
      :disabled="PENDING_STRIPE.includes(status)"
      @click="emit('on-click-empty-table')"
    >
      {{ button }}
    </button>
  </div>
</template>
